import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-missing',
  templateUrl: './feature-missing.component.html',
  styleUrls: ['./feature-missing.component.css']
})
export class FeatureMissingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
